module.exports = __webpack_public_path__ + "img/partners-hero.83db0fb5.jpg";